import { ImageWrapper } from "@/lib/styles";
import styled from "styled-components";

export const Wrapper = styled(ImageWrapper)`
  background: white;
  margin: auto;
  width: 14.25rem;

  ${({ theme }) => theme.mediaQueries.tablet} {
    width: 30rem;
  }
  ${({ theme }) => theme.mediaQueries.laptop} {
    width: 19.625rem;
  }
  ${({ theme }) => theme.mediaQueries.desktop} {
    width: 28.25rem;
  }
`;
